<section class="section-white" *ngIf="featuresData">
  <div [ngClass]="hasInside ? 'section-container-inside' : 'section-container'">
    <div class="career-feature-2">
      <img
        class="img-align-b border-radius"
        src="{{ featuresData?.image?.[0]?.fields?.file?.url }}"
      />
      <div>
        <h2 class="section-heading mar-b-32 text-align-l">
          {{ featuresData?.title }}
        </h2>
        <div
          class="section-description mar-b-48 text-align-l"
          [innerHtml]="featuresData?.content | toHtml"
        ></div>
        <ul class="features-list">
          <li *ngFor="let item of featuresData?.component1">
            <img src="{{ item?.fields?.imageicon?.fields?.file?.url }}" />
            {{ item?.fields?.title }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
